import { Box, Typography } from '@mui/material'
import { useMutation } from '@tanstack/react-query'
import { createRequestToUpgradePlan } from 'api'
import { DialogContent, ToastContent } from 'elements/feedback'
import { renderTextField } from 'elements/inputs'
import { useValidations } from 'lib/form-utils'
import { Controller, useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'

const formId = 'CONTACT_US_FORM'

type FormValues = { message: string }

type ContactUsFormProps = {
  onClose: () => void
}

export const ContactUsForm = ({ onClose }: ContactUsFormProps) => {
  const { t } = useTranslation()

  const rules = useValidations()

  const {
    control,
    handleSubmit,
    formState: { isDirty },
  } = useForm<FormValues>({
    defaultValues: {
      message: '',
    },
  })

  const $createRequestToUpgradePlan = useMutation(createRequestToUpgradePlan)

  return (
    <DialogContent
      title={t('contact_us.contact_us')}
      isActionLoading={$createRequestToUpgradePlan.isLoading}
      externalFormId={formId}
      onDeny={onClose}
      denyText={t('common.cancel')}
      confirmText={t('common.send')}
      isConfirmDisabled={!isDirty}
    >
      <Box
        id={formId}
        component="form"
        onSubmit={handleSubmit(({ message }) =>
          $createRequestToUpgradePlan.mutate(
            { message },
            {
              onSuccess: () => {
                onClose()
                toast.success(
                  <ToastContent
                    title={t('contact_us.message_successfully_sent')}
                  />,
                )
              },
            },
          ),
        )}
      >
        <Typography
          variant="caption1"
          mr={2}
          color="text.secondary"
          display="block"
        >
          {t('contact_us.get_in_touch_with_us')}
        </Typography>

        <Typography
          variant="caption1"
          color="text.secondary"
          display="block"
          mr={2}
          mb={1}
        >
          {t('contact_us.feel_free_to_leave_comment')}
        </Typography>

        <Controller
          name="message"
          control={control}
          rules={{ ...rules.required, validate: rules.maxLength(500) }}
          render={renderTextField({
            rows: 3,
            multiline: true,
            label: t('common.message'),
          })}
        />
      </Box>
    </DialogContent>
  )
}
